/** Report-only monthly axes. Does not change any metric values or shared legacy builders. */
export const monthlyTrendKeys = new Set([
  'sleepAge', 'agingPace', 'recovery', 'tst', 'sol', 'sri', 'waso', 'se', 'deep',
  'stageComp', 'ahi', 'snoreIndex', 'hrvbl', 'rrbl', 'hrbl', 'env',
])

// Same cadence as legacy getInterval, anchored to the last category, not today.
export function monthlyTickInterval(total) {
  const step = total <= 8 ? 1 : total <= 30 ? 2 : 14
  return index => index % step === (total - 1) % step
}

export function monthlyDateLabel(value) {
  const iso = String(value).match(/^\d{4}-(\d{2})-(\d{2})$/)
  return iso ? `${Number(iso[1])}-${Number(iso[2])}` : String(value)
}

export function monthlyCategoryAxis(dates) {
  return {
    // Legacy builders encode x as unpadded M-D strings (including baseline bands).
    // ISO labels would create different ordinal identities, yielding NaN layouts.
    // Keep the caller's full dates untouched for calendar validation/tooltips.
    type: 'category', data: dates.map(monthlyDateLabel), boundaryGap: true, min: null, max: null,
    axisTick: { alignWithLabel: true },
    axisLabel: { showMinLabel: true, showMaxLabel: true, fontSize: 10, rotate: 45,
      interval: monthlyTickInterval(dates.length), formatter: monthlyDateLabel },
  }
}

// Fixed plot gutters, not containLabel's per-metric text measurements: equal
// dates must land at equal pixels even with hours, scores or two value axes.
export const monthlyPlotGrid = { left: 48, right: 36, bottom: 44, containLabel: false }

export function alignMonthlyTrendAxis(chart, points) {
  // Legacy SRI intentionally returns before creating Cartesian axes when history
  // is empty. Adding only xAxis then crashes ECharts; leave that blank chart alone.
  if (!chart.getOption().yAxis?.length) return
  chart.setOption({ xAxis: monthlyCategoryAxis(points.map(point => point.date)), grid: monthlyPlotGrid })
}
